import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const cardClass = 'flex-1 text-center font-bold border-2 border-slate-200 rounded-xl p-3 text-slate-700 hover:bg-slate-50 hover:border-slate-300 transition-colors';

class Home extends Component {

  render(){
    const isAuthenticated = !!localStorage.getItem('auth');

    return (
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <h1 className="text-xl font-bold text-slate-800">Randevu Takip | Uzm. Dr. Zeliha Aksoy</h1>

        {isAuthenticated && (
        <div>
          <div className="flex flex-col md:flex-row gap-3 mt-4">
            <NavLink to="/gunluk-randevular" className={cardClass}>Bugünkü Randevular</NavLink>
            <NavLink to="/gelecek-randevular" className={cardClass}>Gelecek Randevular</NavLink>
            <NavLink to="/randevular" className={cardClass}>Geçmiş Randevular</NavLink>
          </div>
          <div className="flex flex-col md:flex-row gap-3 mt-4">
            <NavLink to="/randevu-ekle" className={cardClass}>Randevu Ekle</NavLink>
          </div>
          </div>
        )}
      </div>
    );
  }
}

export default Home
